import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import {
  Avatar,
  Box,
  Button,
  Grid,
  InputAdornment,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Typography,
  useTheme
} from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import LanguageData from "../../configs/LanguageData.json";
import { getBase64 } from "../../pages/new-ticket/LatestTicket/Form";
import { iFormData } from "../../pages/new-ticket/LatestTicket/Type";
import { getAssetInfo } from "../../redux/actions/AssetsManagement/Assets";
import {
  getContactAid,
  getContactAidById,
  triggerAppAlert,
} from "../../redux/actions/SelfServicePortal/ContactAid/ContactAid";
import {
  getCategory,
  sspSingleCategory,
} from "../../redux/actions/SystemManagement/AddCategory";
import { suggestArticlesAction } from "../../redux/actions/TicketsManagement/TicketsManagement";
import { IState } from "../../redux/reducers/rootReducers";
import { addNewTicket } from "../../services/dashboard/dashboard.service";
import {
  fileUploadService,
  fileUploadServiceForBloeStorage,
} from "../../services/fileUpload/FileUpload";
import CustomSelect from "../common/customSelect/CustomSelect";
import CustomFormLabel from "../common/form-label/CustomFormLabel ";
import ConfirmationPopup from '../common2/ConfirmationPopup';
import AddAttachmentBlobWithPreview from "../EmailTemplates/AddAttachmentBlobWithPreview";
import { useTicketAddUpdatePopupStyles } from "../TicketManagementSystem/Modules/AddUpdatePopup";
import ArticleSuggestion, { SuggestionModalActions } from "../TicketManagementSystem/Modules/ArticleSuggestionModal";
import { WebFormTextArea } from "../webForms/FieldTypes/TextArea";
import { iWebFormField } from "../webForms/schema";
import SelectWebformField from "../webForms/SelectWebformField";
export const addTicketAsContactUrl = "user/Ticket";
const summaryconfigs: iWebFormField = {
  fieldPlaceholder: "Please Enter your Issue Description",
  fieldDescription: "",
  fieldLabel: "Description",
  isMandatory: true,
  removeRequired: false,
  id: "webFormDescription",
};
const isThumbsUp = 6
const blobToBase64 = async (blob: any) => {
  return new Promise<string>((resolve, reject) => {
    const reader: any = new FileReader();
    reader.onloadend = () => {
      resolve(reader?.result?.split(",")[1] || ""); // Remove the 'data:...' prefix
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

const sendRecordingToBackend = async (mediaBlobUrl: any) => {
  if (mediaBlobUrl) {
    try {
      // console.log("Fetching blob from URL:", mediaBlobUrl);

      // Fetch the Blob from mediaBlobUrl
      const response = await fetch(mediaBlobUrl);
      const blob = await response.blob();
      const base64String = await blobToBase64(blob);
      // Convert Blob to File
      const file = new File([blob], `recording_ss.mp4`, { type: "video/mp4" });
      // console.log("Converted file:", file);
      // Create FormData and append file
      const formData = new FormData();
      formData.append("file", file);

      return {
        file: file,
        blob: base64String,
      };
    } catch (error) {
      console.error("Error uploading file:", error);
      return false;
    }
  }
};
const validateWebForm = (enteredVal: any = {}, fields = []) => {
  let errObj: any = {
    hasError: false,
  };
  if (enteredVal["webFormDescription"].trim().length === 0) {
    errObj["webFormDescription"] = "Please fill this field";
    errObj.hasError = true;
  }
  if (!enteredVal["Category"] || enteredVal["Category"] === "Please Select") {
    errObj["Category"] = "Please select a category";
    errObj.hasError = true;
  }
  fields.map((i: any) => {
    // errObj[i.fieldId] =
    if(i.fieldType === "Email" && enteredVal[i.fieldId] && enteredVal[i.fieldId].trim() !=="" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(enteredVal[i.fieldId])) {
      errObj[i.fieldId] = "Please enter a valid email address";
      errObj.hasError = true;
      return errObj;
    }

    if (!i.isMandatory || !i.show) return;
    let fieldVal = enteredVal[i.fieldId];
    if (
      !fieldVal ||
      !fieldVal?.trim ||
      enteredVal[i.fieldId].replaceAll("pleaseSelect", "").trim().length === 0
    ) {
      errObj[i.fieldId] = "Please fill this field";
      errObj.hasError = true;
    }
  });
  // console.log("validateWebForm", enteredVal, fields, errObj);
  return errObj;
};
interface StringObject {
  [key: string]: string;
}
const mergeCheckBoxValues = (obj: StringObject) => {
  try {
    const tempObj: StringObject = {};
    Object.keys(obj).map((i) => {
      if (i.indexOf("checkBox_") === 0) {
        let key = i.split("_")[1];
        tempObj[key] = (tempObj[key] ? tempObj[key] + "," : "") + obj[i];
      } else {
        tempObj[i] = obj[i];
      }
    });
    return tempObj;
  } catch (error) {
    // console.log("mergeCheckBoxValuesERROR", error);
    return obj;
  }
};
const ViewService = (props: any) => {
  // console.log("contactAid__",props)
  const path = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();

  const currContact = useSelector(
    (state: IState) => state?.ContactsReducer?.loggedContact
  );
  const suggestionModalTicketInfo = useSelector((state: IState) => state?.TicketViewReducer?.articleModal?.ticketInfo);
  const searchPath = path.search;

  const searchParams = new URLSearchParams(searchPath);

  const mediaBlobUrl = useSelector(
    (state: any) => state.recording.mediaBlobUrl
  );

  const srd: any = searchParams.get("srd");

  // console.log("search path for new", srd);

  const {
    AllContactAid = [],
    ContactAidById = {},
    dispatch,
    ContactAidImages = {},
    loggedInUser = {},
  } = props;
  const [showForm, setShowForm] = useState<boolean>(true);
  const [byIdVal, setByIdVal] = useState<any>({});
  const [errValues, setErrValues] = useState<any>({});
  const [attachmentValue, setAttachmentVal] = useState<any>([]);
  const [AllCategory, setAllCategory] = useState<any>([]);
  const [categoryList, setCategoryList] = useState([]);
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [showLoading, setShowLoading] = useState<any>(false);
  const [webformFieldList,setWebformFieldList] = useState<any>([]);
  const [attachmentList, setAttachmentList] = useState<any>([]);
  const [valueCat, setValueCat] = useState<any>(null);
  const [assetdetail,setAssetDetail] = useState<any>([]);
  const [assetType,setAssetType] = useState<any>();
  const [asset,setAsset] = useState<any>();
  const [searchData, setSearchData] = useState("");
  const [alert,setAlert] = useState(false)
  const [tikcetNoNote,setTicketNoNote] = useState<any>()
  const [ticketdetail,setTicketDetail] = useState<any>()
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  useEffect(() => {
    if (
      AllContactAid?.[activeIndex]?.categoryId &&
      AllContactAid?.[activeIndex]?.categoryId !== 0
    ) {
      dispatch(
        sspSingleCategory(
          AllContactAid?.[activeIndex]?.categoryId,
          getCategoryByIdCB
        )
      );
    } else {
      let chosenCategory = AllCategory.find(
        (ele: any) =>
          ele.categoryTicketTypeList[0]?.ticketType?.id ===
          AllContactAid?.[activeIndex]?.ticketTypeId
      );
      if (chosenCategory) {
        dispatch(sspSingleCategory(chosenCategory.id, getCategoryByIdCB));
      }
    }
    if (
      AllContactAid?.[activeIndex]?.id &&
      !ContactAidById?.[AllContactAid?.[activeIndex]?.id]
    ) {
      dispatch(
        getContactAidById(
          AllContactAid[activeIndex].id,
          null,
          "user/ContactAid/details"
        )
      );
    }
    setErrValues({});
  }, [activeIndex, AllCategory,path.search]);
  useEffect(() => {
    if (AllContactAid.length > 0 && activeIndex === -1) {
      setActiveIndex(0);
    }
  }, [AllContactAid,path.search]);

  useEffect(() => {
    // Define the async function inside useEffect
    const fetchData = async () => {
      try {
        let tempV: any = `${mediaBlobUrl}`;

        const res: any = await sendRecordingToBackend(tempV);

        if (res && srd) {
          // console.log("blob get in view service", res);
          setAttachmentList([
            {
              preview: res?.blob,
              fileName: "Recording",
              fileType: res?.file?.type,
              formFile: res?.file,
            },
          ]);
        } else {
          // console.log("blob get in view service", res);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

    // Call the async function
    fetchData();
  }, [mediaBlobUrl]);
  useEffect(() => {
    dispatch(getCategory(getallCategoryCB, "user/Category"));
    if (AllContactAid.length === 0) {
      dispatch(getContactAid(getContactAidCB, "user/ContactAid"));
    } else {
      getContactAidCB("0", AllContactAid);
    }
  }, [path.search]);

  useEffect(() => {
    if(ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.contactAidAssetTypes?.length > 0){
    let assetTypeIds = ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.contactAidAssetTypes.map((ids:any) => ids.assetTypeId)
    let thirdPartyId = ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.thirdPartyOrganisationId ? ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.thirdPartyOrganisationId : 0 ;
    const assetInfo = async() => {
      let res = await getAssetInfo(assetTypeIds,thirdPartyId)
      if(res && res?.length > 0){
        setAssetDetail(res)
      }
    }
    assetInfo()
  }
  },[ContactAidById?.[AllContactAid?.[activeIndex]?.id],path.search])
  const assetsFilter = useMemo(() => {
    let assetOptions =  assetdetail.map((asset:any) => ({
      label: asset?.name,
      value: asset?.id,
    ...asset,
    }))
    return assetOptions.filter((item:any) => item?.assetType?.id  == assetType?.assetTypeId)
  },[assetType])
  

  const assetTypeOptions = useMemo(() => {
    const assetTypeList = ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.contactAidAssetTypes
    if(!assetTypeList) return []
    return assetTypeList.map((asset: any) => ({
    label: asset.assetType.name,
    value: asset.assetTypeId,
    ...asset,
  }));
  },[ContactAidById, AllContactAid, activeIndex])  
    
  const getContactAidCB = (resStatus: string, arr: any[] = []) => {
    const id: any = new URLSearchParams(searchPath).get("id");
    if (id && resStatus === "0") {
      arr.map((i: any, index: number) => {
        if (i.id === +id) setActiveIndex(index);
      });
    }
  };

  const ticketCreation = async (payload: any) => {
    // console.log("payload", payload);
    let newTicket: any = await addNewTicket(payload, addTicketAsContactUrl);
    return newTicket;
  };
  const onchangeCategory = useCallback((e: any) => {
    setValueCat(e);
  }, []);
  const ticketSubmit = (request: any) => {
    
    ticketCreation(request).then((res: any) => {
      if (res.status == 200 || res.status == 201) {
        closeArticleModal();
        // console.log("ticketCreation_res", res);
        res?.data?.ticketLogs?.ticketLogAttachmentsList?.map(
          (item: any, index: number) => {
            fileUploadServiceForBloeStorage(
              item?.attachmentPath,
              attachmentList[index]?.formFile,
              (isDone: any, res: any) => {
                if (isDone) {
                  // console.log("inputFileHandler file uploaded", res);
                } else {
                  // console.log("inputFileHandler file failed", res);
                }
              }
            );
          }
        );
        dispatch(
          triggerAppAlert(
            `${LanguageData.SUCCESS} ${res?.data?.id} ${LanguageData.TICKET_CREATED}`,
            "success"
          )
        );
        setTimeout(() => {
          navigate("/workCenter");
          // resetForm();
        }, 1000);
      }
    }).catch((err) => {
        closeArticleModal();
    });
  };
  const onFormSubmit = (event: any) => {
    event.preventDefault();

    const formData = new FormData(event.currentTarget);
    // console.log("attachmentValue", attachmentList);

    let data: iFormData = {};
    formData.forEach((value, key) => {
      data[key] = value.toString();
    });
    data = mergeCheckBoxValues(data);
    const attachmentPaths = attachmentList?.map((item: any) => {
      return {
        AttachmentPath: item.fileName ? item.fileName : item.attachmentPath,
      };
    });

    // const webformFieldList =webformFieldLis/t || [];
    const validationVal: any = validateWebForm(data, webformFieldList);
    setErrValues(validationVal);
    // if (validationVal.hasError) return;
    if (validationVal.hasError) {

    // Remove previous error styles first
    document.querySelectorAll(".vs-error").forEach((el) => {
      el.classList.remove("vs-error");
    });

    Object.keys(validationVal).forEach((key) => {
      if (key === "hasError") return;

      const element: any = document.getElementsByName(key)?.[0];
      if (element) {
        const wrapper = element.closest(".MuiFormControl-root");
        wrapper?.classList.add("vs-error");
      }
    });

  //   // Scroll to first invalid
  //   const firstErrorKey = Object.keys(validationVal).find(
  //     (k) => k !== "hasError"
  //   );

  //   if (firstErrorKey) {
  //     const el = document.getElementsByName(firstErrorKey)?.[0];
  //     el?.scrollIntoView({ behavior: "smooth", block: "center" });
  //   }
    const firstErrorKey = Object.keys(validationVal).find(
      (k) => k !== "hasError"
    );
    if (firstErrorKey) {
      let el: any = null;
      // Normal inputs first
      el = document.getElementsByName(firstErrorKey)?.[0];
      //If not found, it might be a checkbox group
      if (!el) {
        const checkboxInput = document.querySelector(
          `input[name^="checkBox_${firstErrorKey}_"]`
        );
        if (checkboxInput) {
          //Scroll to the checkbox container instead of tiny input
          el = checkboxInput.closest(".webForm-checkboxholder") || checkboxInput;
        }
      }
      //Scroll if element exists
      el?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
      return;
    }

    const currentAid = AllContactAid?.[activeIndex];
    // console.log("onFormSubmit", data, webformFieldList);
    // console.log("webformFieldList", data);
    webformFieldList.map((i: any) => {
      const { fieldType, id } = i;
      if (fieldType === "DatePicker" && data[id]) {
        data[id] = new Date(data[id]).toISOString();
      }
    });
    // console.log("webformFieldList1", data);
    let ticketAssetList = [];
    // if(asset && asset.length > 0){
    //   ticketAssetList = asset?.map((tAsset:any) => ({
    //   id:0,
    //   assetId:tAsset.id
    // }))
    // }
    // console.log("asset final__",asset)
        if (asset) {
        ticketAssetList.push({
          id: 0,
          assetId: asset?.id
        });
      }
    const filteredWebformValues = byIdVal?.webform.webformFieldList?.filter((i:any) => data[i.fieldId] && data[i.fieldId].trim() !== ""); 
    const webformValues= {
      isNew: true,
      webformValues : filteredWebformValues.map((i:any)=>{
        const { webformId, fieldId, fieldType, fieldLabel } = i;
        return {webformId,fieldId,fieldType,fieldLabel,value : data[fieldId] || ""};
      })

    }
    let request: any = {
      sourceCode: "SSP",
      contactAidId: currentAid?.id || 0,
      ticketAssetList:ticketAssetList,
      ticketLogs: {
        statusId: 0, //currentAid?.agentId ? 2 : 1,
        categoryId: valueCat?.id || 0,
        agentId: currentAid?.agentId || 0,
        groupId: currentAid?.groupId || 0,
        ticketTypeId: currentAid?.ticketTypeId || 0,
        description: data.webFormDescription || "",
        title: `${data.webFormDescription || ""}`.substring(0, 100),
        sourceCode: "SSP",
        contactId: loggedInUser?.id || 0,
        webformvalues: `${JSON.stringify(webformValues)}`,
        webformId: byIdVal?.webform?.id || 0,
        circulationListTO: currContact?.email,
        ticketLogAttachmentsList: attachmentPaths,
        PriorityId:ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.priorityId || 0
      },
    };
    // request.ticketLogs.ticketLogAttachmentsList = attachmentValue?.map(
    //   (i: any) => {
    //     let tempObj = { attachmentId: i.id, attachmentPath: i.attachmentPath };
    //     return tempObj;
    //   }
    // );

    const preference = JSON.parse(currContact?.contactPreferences?.TicketDashboardFilterValues || "{}");

    if(preference?.suggestArticles){
      dispatch(suggestArticlesAction(request, true, currContact, null, ticketSubmit));
    } else {
      ticketSubmit(request);
    }

  }
 
  useEffect(() => {
    setByIdVal(ContactAidById?.[AllContactAid?.[activeIndex]?.id] || {});
  }, [ContactAidById, AllContactAid, activeIndex,path.search]);

  const handleFieldChange = (fieldId: string, value: any,children?:boolean) => {
    setWebformFieldList((old:any)=>{

      return old.map((i:any)=>{
          const isVisibleField = i?.visibility?.field.id === +fieldId;
          let visibilityValues = Array.isArray(i?.visibility?.value)
            ? i?.visibility?.value
            : [i?.visibility?.value];
          visibilityValues =  visibilityValues.map((i:any)=> i?.toString().trim());
          const selectedValues = Array.isArray(value)
            ? value
            : [value];
          const matchesVisibility = visibilityValues.some((item: any) => selectedValues.includes(item));

          if(isVisibleField && matchesVisibility && !children){
              i.show = true;
          }else if(isVisibleField){
              i.show = false;
              handleFieldChange(i.id,null,true);
          }
          return i;
      });
    });
  }
  useEffect(()=>{
    setWebformFieldList((byIdVal?.webform?.webformFieldList ?? []).map((i:any)=>{
      return {...i,show:i.visibility ? false : true};
    }));
  },[byIdVal?.webform?.webformFieldList])
  const webFormFields = useMemo(
    () => (
      <>
        {webformFieldList &&
          webformFieldList.map((i: any) => {
            const { fieldLabel, fieldType, fieldPlaceholder, fieldId } = i;
            i.id = fieldId;
            return (
              (!i.visibility || (i.visibility && i.show)) &&
              <Box className="webform-fields-holder">
                <SelectWebformField onChange={(value) => handleFieldChange(fieldId, value)} block={i} />
                {errValues?.[fieldId] && (
                  <Typography variant="caption" className="Newerror-text">
                    {errValues?.[fieldId]}
                  </Typography>
                )}
              </Box>
            );
          })}
      </>
    ),
    [webformFieldList, errValues]
  );

  function truncateString(str: string) {
    if (str.length > 5) {
      return str.substring(0, 8) + "...";
    }
    return str;
  }
  const imgCallBack = async (params: any, file: any) => {
    let fileObject = {
      description: file.name,
      filetypeid: 1,
      formFile: file,
    };
    let fileUpload: any = await fileUploadService(
      fileObject,
      () => {},
      () => {}
    );
    if (fileUpload.status == 201) {
      // console.log("file upload success ", fileUpload);
      let recs: {
        file: any;
        fileName: string;
        id: any;
        attachmentPath: any;
      }[] = attachmentValue || [];
      recs.push({
        file: params,
        fileName: truncateString(file.name),
        id: fileUpload.data.id,
        attachmentPath: fileUpload.data.filePath,
      });
      setAttachmentVal([...recs]);
    } else {
    }
  };
  const getCategoryByIdCB = (resStatus: string, res: any) => {
    let temp: any = [];
    if(AllContactAid?.[activeIndex]?.category && AllContactAid?.[activeIndex]?.category?.isActive){
      let cat = AllContactAid?.[activeIndex]?.category;
      temp.unshift({
        label: cat.name,
        name: cat.name,
        value: cat.id,
        id: cat.id,
      });
    }
    if (resStatus === "0") {
      res?.forEach((item: any) => {
        if (item.isActive) {
          let a: any = {
            label: `${item.name}`,
            name: item.name,
            value: item.id,
            id: item.id,
          };
          temp.push(a);
        }
      });
    }

    // if (temp.length > 0) {
    //     setValueCat(temp[0]);
    // }else {
    //     setValueCat(null);  
    // }
    setCategoryList(temp);
  };

  const onRemoveAttchment = (index: number) => {
    let allRecs = attachmentValue;
    allRecs.splice(index, 1);
    setAttachmentVal([...allRecs]);
  };

  const getallCategoryCB = (resStatus: string, res: any) => {
    if (resStatus === "0") {
      setAllCategory(res);
    }
  };
  const articleSuggestionCB = (feedbackType: 'like' |'dislike' | undefined ,statusId: number,ticketInfo:any,articleName:any) => {
    if(feedbackType == 'like'){
      setTicketNoNote(ticketInfo)
      const updatedTicketInfo = {
            ...ticketInfo,
            ticketLogs: {
              ...ticketInfo.ticketLogs,
              note: `Article : '${articleName || ""}' resolved the issue.`
            }
          };
        setTicketDetail(updatedTicketInfo)
        closeArticleModal()
        setAlert(true)
      }else{
        statusId =  ticketInfo?.ticketLogs?.statusId; //feedbackType === 'like' ? statusId :
        ticketSubmit({...ticketInfo, ticketLogs: {...ticketInfo.ticketLogs, statusId} });
      }
  };
  const closeArticleModal = () => {
       dispatch({
          type: "ARTICLE_SUGGESTION_POPUP_INFO",
          payload: null
        });
  };
  const classes = useTicketAddUpdatePopupStyles();
  const greyHoverStyles = {
    option: (styles: any, { isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: isSelected
        ? "#ffffff"
        : isFocused
        ? "#d2e8f8"
        : "#ffffff",
      color: isFocused && theme.palette.mode === "dark" ? "#000" : theme.palette.mode === "dark" ? "#ffffff" : "#000",
      background: isFocused ? "#daebf8" : (theme.palette.mode === "dark" ? "#3f4044" : "#ffffff"),
      cursor: "pointer",
    }),
  };
  const handleSearch = (e: any) => {
    setSearchData(e.target.value);
  };
  const Proceed = () => {
    let ticketInfo = ticketdetail
    let statusId = isThumbsUp
    ticketSubmit({...ticketInfo, ticketLogs: {...ticketInfo.ticketLogs, statusId} });
    setAlert(false)
  }
  const closeAlert = () => {
     let ticketInfo = tikcetNoNote
    let statusId =  ticketInfo?.ticketLogs?.statusId;
    ticketSubmit({...ticketInfo, ticketLogs: {...ticketInfo.ticketLogs, statusId} });
  }

  return (
    <>
    {alert && 
          <ConfirmationPopup 
              onClose = {closeAlert}
              onSubmit = {Proceed}
              title = "Confirmation" 
              buttonLabel="OK"
              desc={<><span style={{fontSize:'16px'}}>Thanks for using self help. By selecting OK this issue will be Resolved and no further action taken</span></>}
          />
      }
      {suggestionModalTicketInfo &&
        <Box className={`${classes.popupHolder}  add-update-modal ${suggestionModalTicketInfo?.fullScreen ? 'fullScreenModal' : ''}`}>
          <Box className="modal-dialog">
            <Box className="modal-content">
              <Box className="modal-header">
                <Typography variant="h6" className="txtCapitalize">
                  Quick Fix Suggestions
                </Typography>
                <Box className={`gap15 ${classes.row}`}>

                  <SuggestionModalActions modalInfo={suggestionModalTicketInfo}/>

                  <Typography
                    className="cursor-pointer"
                    onClick={() => ticketSubmit(suggestionModalTicketInfo)}
                  >
                    <CloseIcon className="cursor-pointer" />
                  </Typography>
                </Box>
              </Box>
              <ArticleSuggestion isSSP={true} callback={articleSuggestionCB} />
            </Box>
          </Box>
        </Box>
      }
      {AllContactAid?.length > 0 ? (
        <Box className="view-service">
          <Grid container justifyContent={"space-between"} spacing={0}>
            <Grid item md={6} xs={12}>
              <Grid container justifyContent={"space-between"} spacing={0} sx={{margin:"32px"}}>
                <Grid item md={3} xs={12} className="viewservice-usericon">
                  <Avatar
                    sx={{ height: 130, width: 130 }}
                    alt={AllContactAid?.[activeIndex]?.name}
                    src={`${
                      AllContactAid?.[activeIndex]?.systemIcons?.filePath || ""
                    }`}
                  />
                </Grid>
                <Grid item md={9} xs={12}>
                  <Typography variant="h6">
                    {AllContactAid?.[activeIndex]?.name}
                  </Typography>
                  <Typography className="aid_desc" variant="body2">
                    {AllContactAid?.[activeIndex]?.description}
                  </Typography>
                  {AllContactAid?.[activeIndex]?.cost ?
                   <Typography variant="body2">
                    <span className="text-primary">Cost : </span>
                    <span>{AllContactAid?.[activeIndex]?.cost}</span>
                  </Typography>:''
                  }
                 
                </Grid>
                <Grid item md={12} xs={12}>
                  <hr />
                </Grid>
                <Grid item md={12} xs={12}>
                  <form onSubmit={onFormSubmit}>
                    <Grid item md={12} xs={12}>
                      <CustomFormLabel
                        classNames="ssp-create-request-label"
                        labelName={"Category"}
                        isMandotary={true}
                      />
                      <CustomSelect
                        isMulti={false}
                        isOpen={false}
                        placeholder="Please Select"
                        width={"100%"}
                        name="Category"
                        isColor={false}
                        isDisabled={false}
                        isError={errValues?.["Category"]}
                        defaultValue={valueCat}
                        options={categoryList}
                        helperText={errValues?.["Category"]}
                        handleChange={onchangeCategory}
                        customClassNames="sml-txt-dropdown new-service"
                        styleProp={greyHoverStyles}
                      />
                      <br />
                    </Grid>
                    <WebFormTextArea
                      fieldConfig={summaryconfigs}
                      value={null}
                      editable={true}
                    />
                    {errValues?.["webFormDescription"] && (
                      <Typography variant="caption" className="Newerror-text ">
                        {errValues["webFormDescription"]}
                      </Typography>
                    )}
                     <br />
            {ContactAidById?.[AllContactAid?.[activeIndex]?.id]?.contactAidAssetTypes?.length > 0 && (         
              <>
              <Grid item md={12} xs={12}>
                    <CustomFormLabel
                          labelName={"Asset Type"}
                          isMandotary={false}
                      />
                    <CustomSelect
                        isOpen={false}
                        placeholder="Asset Type"
                        width={"100%"}
                        name="assetType"
                        isColor={false}
                        isDisabled={false}
                        isError={false}
                        helperText={""}
                        defaultValue={assetType}
                        options={assetTypeOptions}
                        handleChange={(e: any) => {
                            setAssetType(e)
                            setAsset([])
                        }}
                        isMulti={false}
                        customClassNames=" new-service"
                    />
              </Grid>
              <Grid item md={12} xs={12}>
                    <CustomFormLabel
                          labelName={"Asset"}
                          isMandotary={false}
                      />
                    <CustomSelect
                        isOpen={false}
                        placeholder="Asset"
                        width={"100%"}
                        name="asset"
                        isColor={false}
                        isDisabled={false}
                        isError={false}
                        helperText={""}
                        defaultValue={asset}
                        options={assetsFilter}
                        handleChange={(e: any) => {
                           setAsset(e)
                        }}
                        isMulti={false}
                        customClassNames=" new-service"
                    />
                      <span style={{ fontSize: "12px", color: "#c8c8c8" }}>
                    * Please select an asset type before selecting an asset
                    </span>
              </Grid>
               {/* <Grid item md={12} xs={12}>
                     <CustomMultiselect
                        placeholder={"Asset"}
                        minHeight={53}
                        isColor={true}
                        isDisabled={false}
                        classNames="h-inputs p-0"
                        defaultValue={asset}
                        options={assetsFilter}
                        handleChange={(e: any) => { 
                            setAsset(e)
                        } }
                        isMulti={true}
                        title='Asset'
                    />
                    <span style={{ fontSize: "12px", color: "#c8c8c8" }}>
                    * Please select an asset type before selecting an asset
                    </span>
                </Grid> */}
              </>
            )}
                    {byIdVal && byIdVal?.webform && webFormFields}
                    <Grid
                      item
                      md={12}
                      xs={12}
                      className="spp-newtickets-attachment"
                    >
                      <input
                        id="AssetFileUpload"
                        accept=".jpeg,  .png, .pdf"
                        type="file"
                        multiple={true}
                        onChange={(e: any) => {
                          getBase64(e.target.files[0], imgCallBack);

                          // imgCallBack(e.target.files)
                        }}
                        className="d-none"
                      />
                      <AddAttachmentBlobWithPreview
                        accept={
                          ".pdf,.doc,.docx,.jpg,.jpeg,.png,.zip,.txt,.xls,.xlsx,.mp4,.bmp"
                        }
                        type="Attachment"
                        isAttachmentOnFly={false}
                        isShowBtn={true}
                        attachmentList={attachmentList}
                        setAttachmentList={setAttachmentList}
                        btnLabel="Add Attachments"
                      />
                    </Grid>
                    <Grid item md={12} xs={12}>
                      <Box className="pt-1 text-center">
                        <Button type="submit" variant="contained">
                          Create Ticket
                        </Button>
                      </Box>
                    </Grid>
                  </form>
                </Grid>
              </Grid>
            </Grid>
            <Grid item md={4} xs={12} className="p-1" sx={(theme) => ({ borderLeft: theme.palette.mode === "dark" ? "8px solid #000" : "8px solid #ebeffc",})}>
              <aside className="aside viewservice-services" style={{ maxHeight: "calc(100vh - 120px)", display: "flex", flexDirection: "column", marginLeft: "20px", borderRadius: "8px" }}>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems={{ xs: "stretch", sm: "center" }}
                  flexDirection={{ xs: "column", sm: "row" }}
                  gap={2}
                  sx={{ mb: 1 }}
                >
                  <Typography variant="h6" className="services-title">
                    Services
                  </Typography>

                  <TextField
                    size="small"
                    placeholder="Search..."
                    value={searchData}
                    onChange={handleSearch}
                    className="serviceSearch"
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      width: {
                        xs: "100%",
                        sm: 230,
                        md: 290,
                        lg: 370,
                        xl: 410,
                      },
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "#3f4044" : "#fff",
                        borderRadius: "10px",
                        paddingRight: { xs: "6px", sm: "8px", md: "10px" },
                      },
                      "& .MuiInputBase-input": {
                        padding: { xs: "10px 2px", sm: "10px 4px", md: "12px 6px" },
                      },
                    }}
                  />
                </Box>
                <hr style={{ margin: 0, color: "#e0e0e0" }} />
                <div style={{ overflowY: "auto", flex: 1 }}>
                  {AllContactAid.filter((i: any) =>
                    i.name?.toLowerCase().includes(searchData.toLowerCase())
                  ).length === 0 ? (
                    <Typography
                      variant="body2"
                      sx={{
                        textAlign: "center",
                        mt: 2,
                        color: "text.secondary",
                      }}
                    >
                      No records found...
                    </Typography>
                  ) : (
                    <AidList
                      // listVal={AllContactAid}
                      listVal={AllContactAid.filter((i: any) =>
                        i.name?.toLowerCase().includes(searchData.toLowerCase())
                      )}
                      originalList={AllContactAid}
                      ContactAidImages={ContactAidImages}
                      activeIndex={activeIndex}
                      callback={setActiveIndex}
                    />
                  )}
                </div>
              </aside>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <Box className="p-2 white-bg">
          <Typography variant="h5">No Services Found</Typography>
        </Box>
      )}
    </>
  );
};

const AidList = (props: any) => {
  const navigate = useNavigate();
  const {
    listVal = [],
    originalList = [],
    activeIndex = 0,
    callback,
    ContactAidImages = {},
  } = props;
  return (
    <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }}>
      {listVal.map((i: any, index: number) => {
        return (
          <>
            <ListItem
              key={index}
              onClick={() => {
                // callback(index);
                const originalIndex = originalList.findIndex(
                  (item: any) => item.id === i.id
                );
                callback(originalIndex);
                navigate(`/viewService?id=${i?.id}`)
              }}
              className={`aid_list_items ${
                activeIndex === index ? "active" : ""
              }`}
              alignItems="center"
            >
              <ListItemAvatar>
                <Avatar
                  sx={{ height: 30, width: 30 }}
                  alt={i.name}
                  src={i?.systemIcons?.filePath || ""}
                />
              </ListItemAvatar>
              <ListItemText
                primary={i.name}
                secondary={<>{/* {i.description} */}</>}
              />
            </ListItem>
          </>
        );
      })}
    </List>
  );
};
const mapStateToProps = (state: IState) => {
  return {
    ContactAidImages: state?.ContactsReducer?.contactImgDetailsById,
    AllContactAid: state?.ContactsReducer?.AllContactAid,
    ContactAidById: state?.ContactsReducer?.ContactAidById,
    loggedInUser: state?.ContactsReducer?.loggedContact,
  };
};

export default connect(mapStateToProps)(ViewService);
